import React from "react";
import { Button, Form } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import { FilePostData } from "../API";
import { toast, ToastContainer } from "react-toastify";

function ReportAdd({ setAddShow, fetchData }) {
  // Yup validation schema
  const validationSchema = Yup.object().shape({
    File: Yup.mixed()
      .required("CSV file is required")
      .test("fileType", "Only .csv files are allowed", (value) => {
        return value && value.name.endsWith(".csv");
      }),
  });

  // Submit handler
  const handleSave = async (values, { setSubmitting, resetForm }) => {
    try {
      const res = await FilePostData(
        "SurveyDetails/BulkAddSurveySubDetails",
        values
      );

      if (res.statusCode === 400) {
        toast.error(res.message,"No valid records found in the uploaded CSV file.");
      } else if (res.statusCode === 200) {
        toast.success("Data uploaded successfully!", {
          position: "top-right",
        });
        setAddShow(false);
        fetchData();
        resetForm();
      } else {
        toast.error("Unexpected response: " + res.message, {
          position: "top-right",
        });
      }
    } catch (error) {
      toast.error("No valid records found in the uploaded CSV file.", {
        position: "top-right",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={{ File: null }}
      validationSchema={validationSchema}
      onSubmit={handleSave}
    >
      {({
        values,
        errors,
        touched,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <Form onSubmit={handleSubmit}>
          <ToastContainer />
          <div className="row filters">
            <div className="col-md-12">
              <Form.Group controlId="csvFile">
                <Form.Label>
                  Upload CSV File <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Control
                  type="file"
                  name="File"
                  accept=".csv"
                  onChange={(event) =>
                    setFieldValue("File", event.currentTarget.files[0])
                  }
                  style={{
                    boxShadow:
                      "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                  }}
                  isInvalid={!!errors.File && touched.File}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.File}
                </Form.Control.Feedback>
              </Form.Group>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Button
              type="submit"
              variant="primary"
              disabled={isSubmitting}
              style={{
                boxShadow:
                  "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
              }}
            >
              {isSubmitting ? "Uploading..." : "SUBMIT"}
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default ReportAdd;
